import { useState, useEffect } from 'react';
import './CartItem.scss';
import { FormattedNumber } from 'react-intl';
import { HiInput } from '@hipay/design-system/components';

function CartItem(props) {
  const [product, setProduct] = useState(props.product);
  const [price, setPrice] = useState(product.price);
  const [error, setError] = useState('');

  useEffect(() => {
    setProduct(props.product);
    setPrice(props.product.price);
  }, [props.product]);

  let handlePriceChanged = (newPrice) => {
    const isValidFormat = () => {
      const parts = newPrice.split('.');
      return (
        parts.length <= 2 &&
        parts[0].length <= 4 &&
        (parts.length === 1 || parts[1].length <= 2)
      );
    };

    const parsedPrice = parseFloat(newPrice);
    const isValidPrice =
      !isNaN(newPrice) &&
      newPrice.trim() !== '' &&
      parsedPrice >= 0 &&
      parsedPrice <= 1000;

    if (newPrice === '' || newPrice.endsWith('.')) {
      return setPrice(newPrice);
    }

    if (isValidPrice && isValidFormat()) {
      let currentProduct = { ...product };
      setPrice(newPrice);
      currentProduct.price = parsedPrice;
      setProduct(currentProduct);
      props.updateCartItems(currentProduct, props.index);
      return setError('');
    }

    setError(
      <>
        {'Le prix doit être compris entre '}
        <FormattedNumber
          value={''}
          // eslint-disable-next-line
          style={'currency'}
          currency={props.currency}
        />
        {' et '}
        <FormattedNumber
          value={'1000'}
          // eslint-disable-next-line
          style={'currency'}
          currency={props.currency}
        />
      </>
    );
  };

  let checkInput = () => {
    let currentProduct = { ...product };

    if (
      typeof currentProduct.price === 'string' &&
      currentProduct.price.endsWith('.')
    ) {
      currentProduct.price += '00';
    } else if (props.total <= 0) {
      currentProduct.price = 0.01;
    }

    setPrice(currentProduct.price);
    currentProduct.price = Number(currentProduct.price);
    setProduct(currentProduct);
    props.updateCartItems(currentProduct, props.index);
    setError('');
  };

  return (
    <div className="CartItem">
      <div className="image">
        <img
          src={`${process.env.PUBLIC_URL}/static/images/items/${product.imageUrl}`}
          alt={product.name}
        />
      </div>

      <div className="name">{product.name}</div>

      <div className="amount">
        {props.env === 'stage' || props.editable ? (
          <HiInput
            value={price ?? ''}
            onChange={handlePriceChanged}
            onBlur={checkInput}
            placeholder="30"
          />
        ) : (
          <FormattedNumber
            value={price ?? ''}
            // eslint-disable-next-line
            style={'currency'}
            currency={props.currency}
          />
        )}
      </div>

      <div className="description">
        {props.product.name !== 'shipping' && (
          <div className="quantity">
            <FormattedNumber
              value={price ?? ''}
              // eslint-disable-next-line
              style={'currency'}
              currency={props.currency}
            />
            {' x '}
            {product.quantity}
          </div>
        )}

        {props.product.name === 'shipping' && (
          <div className="address">
            <div>John Doe</div>
            <div>15 rue de la paix</div>
            <div>75015 PARIS</div>
          </div>
        )}
      </div>
      <div className="error">{error}</div>
    </div>
  );
}

export default CartItem;
